import {IconProps} from './types';

export const EmailCheck: React.FC<IconProps> = ({ 
    className, 
    width = 24, 
    height = 24 
}) => (
    <svg 
        width={width} 
        height={height} 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <g clipPath="url(#clip0_11238_12523)">
            <mask id="mask0_11238_12523" style={{maskType: 'luminance'}} maskUnits="userSpaceOnUse" x="2" y="4" width="23" height="21">
                <path 
                    d="M4 5H20C20.55 5 21 5.45 21 6V18C21 18.55 20.55 19 20 19H4C3.45 19 3 18.55 3 18V6C3 5.45 3.45 5 4 5Z" 
                    stroke="white" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                />
                <path 
                    d="M3 6.5L12 12L21 6.5" 
                    stroke="white" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                />
                <path 
                    d="M19 13C22.31 13 25 15.69 25 19C25 22.31 22.31 25 19 25C15.69 25 13 22.31 13 19C13 15.69 15.69 13 19 13Z" 
                    fill="black"
                />
                <path 
                    d="M16 19L17.75 20.75L21.5 17" 
                    stroke="white" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                />
            </mask>
            <g mask="url(#mask0_11238_12523)">
                <path d="M24 0H0V24H24V0Z" fill="#292929"/>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_11238_12523">
                <rect width="24" height="24" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);
